import React from 'react'

import './style.sass'

function Field({ children, className = '' }) {
  return <div className={`dsar-field-wrapper ${className}`}>{children}</div>
}

export default Field
